import React, { Component } from 'react';

import Header from "../Header/Header"
import Footer from "../Footer/Footer"
import Welcome from '../Welcome/Welcome';
import Candidaets from '../Candidaets/Candidaets';
import Sokrim from '../Sokrim/Sokrim';
import Boxes from '../Boxes/Boxes';
import Videos from '../Videos/Videos';
import Articles from '../Articles/Articles';
import ScrollableAnchor from 'react-scrollable-anchor'
import { interstitial } from '../Services/Adsense/ads';
import { mobile } from '../Services/Agent';
import MapMadlan from '../MapMadlan/MapMadlan';

export default class App extends Component {
  componentDidMount() {
    if (!mobile()) {
      // window.location.href = "https://www.ynet.co.il/home/0,7340,L-26492,00.html";
      window.location.href = "https://www.ynet.co.il/home/0,7340,L-30732,00.html";
      return;
    }
    interstitial();
  }
  render() {
    return (
      <div className="App">
        <Header />
        <Welcome />
        <Videos />
        <ScrollableAnchor id={'section1'}>
          <Candidaets />
        </ScrollableAnchor>
        <ScrollableAnchor id={'section2'}>
          <Sokrim />
        </ScrollableAnchor>
        <ScrollableAnchor id={'section3'}>
          <MapMadlan />
        </ScrollableAnchor>
        <ScrollableAnchor id={'section4'}>
          <Boxes />
        </ScrollableAnchor>
        <Articles />
        <Footer />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/Components/App/App.jsx